import { render, staticRenderFns } from "./LabelHintCustomField.vue?vue&type=template&id=2f2f09cb&scoped=true"
import script from "./LabelHintCustomField.vue?vue&type=script&lang=js"
export * from "./LabelHintCustomField.vue?vue&type=script&lang=js"
import style0 from "./LabelHintCustomField.vue?vue&type=style&index=0&id=2f2f09cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f09cb",
  null
  
)

export default component.exports